var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgUnityUser(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 32,
    height: 32,
    viewBox: "0 0 32 32",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "user") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M29 28h-2c0-2.365-4.479-5-10.906-5s-10.906 2.635-10.906 5h-2c0-3.926 5.669-7 12.906-7s12.906 3.074 12.906 7z"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M16 3c-3.859 0-7 3.141-7 7 0 1.064 0.29 1.924 0.588 2.713l0.29 0.803c0.197 0.559 0.396 1.117 0.64 1.656 0.77 1.705 1.963 2.898 3.449 3.453 0.208 0.078 0.423 0.137 0.713 0.211l0.268 0.062c0.342 0.064 0.693 0.102 1.053 0.102s0.711-0.037 1.050-0.1c0.092-0.018 0.182-0.041 0.342-0.084 0.219-0.055 0.434-0.113 0.64-0.189 1.488-0.557 2.682-1.75 3.451-3.455 0.244-0.539 0.442-1.098 0.64-1.656l0.29-0.803c0.298-0.789 0.588-1.649 0.588-2.713 0-3.859-3.141-7-7-7zM20.541 12.006c-0.105 0.279-0.205 0.562-0.306 0.844-0.178 0.506-0.354 1.010-0.575 1.498-0.381 0.844-1.093 1.943-2.33 2.406-0.136 0.051-0.278 0.086-0.421 0.121-0.109 0.038-0.19 0.039-0.29 0.064-0.427 0.071-0.881 0.072-1.305-0.006l-0.224-0.059c-0.143-0.035-0.285-0.070-0.423-0.123-1.235-0.461-1.947-1.561-2.328-2.404-0.221-0.488-0.397-0.992-0.575-1.498-0.101-0.281-0.2-0.564-0.306-0.844-0.291-0.771-0.459-1.346-0.459-2.006 0-2.758 2.243-5 5-5s5 2.242 5 5c0 0.66-0.168 1.234-0.459 2.006z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgUnityUser);
export default __webpack_public_path__ + "static/media/unity_user.a6f7e26e222f54091b0b130515d9726f.svg";
export { ForwardRef as ReactComponent };